import React, { useEffect, useState,  } from 'react';
import { View, Text, StyleSheet, Platform,  TouchableOpacity, StatusBar, ScrollView, ActivityIndicator } from 'react-native';

import Colors from '../constants/Colors';
import {  Ionicons } from "@expo/vector-icons"
import { useDispatch, useSelector } from 'react-redux';
import {  NativeBaseProvider } from 'native-base';
import {  getCity, SetConfig } from '../store/action/userLogin';










const Register2 = (props) => {






    const [isFetching, setIsFetching] = useState(false);
    const [ALLCity, setALLCity] = useState([]);
    //const tokens = "2|WHyjzuT213icASOZyDMHFmRUaYcJfLA5S9Y9kjhh"
    const tokens = useSelector((store) => store.userLogin.datatoken);
    const dispatch = useDispatch();
    // const isfocuce=useIsFocused()




    const getALLCityHandler = async () => {
        try {
            setIsFetching(true)
            const res = await dispatch(getCity(tokens, props.route.params.ids));
            setALLCity(res.data.data.cities)
            setIsFetching(false);
            //console.log(res.data.data.cities);

        } catch (err) {
            console.log(err);
        }
    };








    useEffect(() => {
        getALLCityHandler()
    }, [])




    const setConfigHandler = async (idcity) => {
        try {
            const res = await SetConfig(tokens,props.route.params.ids,idcity);
             //console.log(res.data);
        } catch (err) {
            console.log(err);
        }
    };






    


    return (


        <NativeBaseProvider>
         
            <View style={styles.viewHeader}>
                <StatusBar backgroundColor={Colors.primary} />
                <TouchableOpacity style={styles.menu}   >
                    <Ionicons onPress={() => props.navigation.goBack()} name="arrow-forward-outline" size={25} color={Colors.background} />
                </TouchableOpacity>

                <View style={styles.textheader}>
                    <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, padding: "5%" }}>
                        انتخاب شهر
                    </Text>
                </View>

            </View>


            <View style={styles.viewtitle}>
                <Text style={{ fontFamily: "MontserratBold", fontSize: 20, position: "absolute" }}>شهر خود را انتخاب کنید</Text>
                {/* <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.secondText3 }}>ابتدا استان و سپس شهر محل اقامت خود را انتخاب کنید</Text> */}
            </View>
            <ScrollView  style={{backgroundColor:Colors.background}}>

                <View style={styles.viewContainer}>












                    {isFetching ?
                        <View style={{ width: "100%", height: "100%", alignItems: "center", justifyContent: "center", backgroundColor: Colors.background }} >
                            <ActivityIndicator
                                animating={isFetching} size={30} color={Colors.primary} />

                            <Text style={{ fontFamily: "MontserratBold", fontSize: 25, color: Colors.primary, marginTop: 30 }}>لطفا شکیبا باشید...</Text>
                        </View>
                        :
                        ALLCity.map((item, i) => {
                            return (

                                <TouchableOpacity key={i} onPress={() => {
                                    setConfigHandler(item.id)
                                   props.navigation.navigate("home")
                                }} style={styles.touch}>
                                    <Ionicons name="arrow-back-outline" size={25} color={Colors.primary} style={{ position: "absolute", left: "5%", top: Platform.OS == "web" ? "28%" : "20%" }} />
                                    <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, position: "absolute", right: "5%", top: Platform.OS == "web" ? "28%" : "20%" }}>{item.city}</Text>
                                </TouchableOpacity>

                            )
                        })}


                </View>
            </ScrollView>
        </NativeBaseProvider>


    );
}

const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background,
        alignItems: "center"
    },
    viewtitle: {
        width: "100%",
        height: 80,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: Colors.background,

    },
    touch: {
        flexDirection: "row",
        width: "90%",
        height: 50,
        backgroundColor: Colors.background2,
        marginTop: 8,
        borderRadius: 10
    },
    viewHeader: {
        flexDirection: "row",
        width: "100%",
        height: 80,
        backgroundColor: Colors.primary,
    },

    menu: {
        backgroundColor: Colors.primary,
        width: 40,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 15,
        top: "35%",

    },
    textheader: {
        backgroundColor: Colors.primary,
        width: 100,
        height: 60,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "12%",
        top: "22%"
    },
})




export default Register2